<template>
  <v-card
    v-if="$vuetify.breakpoint.mdAndUp"
    color="secondary"
    :width="400"
    :height="300"
    :style="shadowStyle"
  >
    <v-img
      height="173"
      width="370"
      style="border-radius: 10px; left: 3.75%; right: 3.75%; top:5%; margin-bottom: 20px"
      :src="gameData.image"
    >
    </v-img>
    <div v-if="gameData.isIndie" class="badge badge-top-right indie-badge">
      <span>Indie</span>
    </div>     
    <div v-if="gameData.isAAA" class="badge badge-top-right AAA-badge">
      <span>AAA</span>
    </div>    
    <div v-if="gameData.isWIP" class="ribbon ribbon-top-left wip-ribbon">
      <span>Work in progress</span>
    </div>
    <div v-if="gameData.isEA" class="ribbon ribbon-top-left ea-ribbon">
      <span>Early access</span>
    </div>
    <div v-if="gameData.isNSFW" class="ribbon ribbon-top-left nsfw-ribbon">
      <span>NSFW</span>
    </div>
    <v-badge
      inline
      color="error"
      content="Work in progress"
      :value="false"
      style="margin-right: 0px;"
    >
      <span class="text name">
        <FitText>{{ gameData.name }}</FitText>
      </span>
    </v-badge>
    <EngineIcon
      _style="cursor:pointer; position: absolute; right: 10px; bottom: 10px; opacity: 0.3"
      :engine="gameData.engine"
      @click="openEngine()"
    />
    <br />
    <v-layout row class="platforms">
      <PlatformIcon
        v-for="(platform, i) in platforms"
        :key="i"
        _style="cursor:pointer"
        @click="openPlatform(platform)"
        :platform="platform"
      />
    </v-layout>
    <div
      style="display:inline-flex; flex-direction: row; margin-top: 10px; cursor:pointer"
      @click="openWebsite()"
    >
      <v-img
        height="25"
        width="25"
        style="margin-left: 12px;border-radius: 15px; max-height: 25px; max-width: 25px"
        class="authorImage"
        :src="gameData.authorImage"
      />
      <span class="text author">{{ gameData.authorName }} from {{ gameData.authorProvince }} </span>
    </div>
  </v-card>
  <v-card
    v-else
    color="secondary"
    :width="270"
    :height="270"
    :style="shadowStyle"
  >
    <v-img
      height="117"
      width="250"
      style="border-radius: 10px; left: 3.75%; right: 3.75%; top:3.75%; margin-bottom: 20px"
      :src="gameData.image"
    >
    </v-img>
    <div v-if="gameData.isAAA" class="badge badge-top-right AAA-badge">
      <span>AAA</span>
    </div>
    <div v-if="gameData.isIndie" class="badge badge-top-right indie-badge">
      <span>Indie</span>
    </div>    
    <div v-if="gameData.isWIP" class="ribbon ribbon-top-left wip-ribbon">
      <span>Work in progress</span>
    </div>
    <div v-if="gameData.isEA" class="ribbon ribbon-top-left ea-ribbon">
      <span>Early access</span>
    </div>
    <div v-if="gameData.isNSFW" class="ribbon ribbon-top-left nsfw-ribbon">
      <span>NSFW</span>
    </div>
    <v-badge
      inline
      color="error"
      content="Work in progress"
      :value="false"
      style="margin-right: 10px;"
    >
      <span class="text name">
        <FitText>{{ gameData.name }}</FitText>
      </span>
    </v-badge>
    <EngineIcon
      _style="cursor:pointer; position: absolute; right: 10px; bottom: 10px; opacity: 0.3"
      :engine="gameData.engine"
      @click="openEngine()"
    />
    <br />
    <v-layout row class="platforms">
      <PlatformIcon
        v-for="(platform, i) in platforms"
        :key="i"
        _style="cursor:pointer"
        @click="openPlatform(platform)"
        :platform="platform"
      />
    </v-layout>
    <div
      style="display:inline-flex; flex-direction: row; margin-top: 10px; cursor:pointer"
      @click="openWebsite()"
    >
      <v-img
        height="25"
        width="25"
        style="margin-left: 12px;border-radius: 15px; max-height: 25px; max-width: 25px"
        class="authorImage"
        :src="gameData.authorImage"
      />
      <span class="text author"> {{ gameData.authorName }} {{ gameData.authorProvince }} </span>
    </div>
  </v-card>
</template>

<script>
import PlatformIcon from "./PlatformIcon";
import EngineIcon from "./EngineIcon";
import FitText from "./FitText";

export default {
  name: "GameCard",
  props: {
    gameData: {
      type: Object,
      required: true,
    },
  },
  components: { PlatformIcon, EngineIcon, FitText },
  computed: {
    dark() {
      return this.$vuetify.theme.dark;
    },
    shadowStyle() {
      return `box-shadow: 8px 8px 17px ${
        this.dark ? "rgba(47,37,111,0.4)" : "rgba(0,0,0,0.4)"
      }; border-radius: 15px; margin-top: 10px; margin-left: 25px; margin-right: 25px; margin-bottom: 30px`;
    },
    platforms() {
      let platforms = [];
      Object.keys(this.gameData.platforms).forEach((key) => {
        if (this.gameData.platforms[key]) platforms.push(key);
      });
      return platforms;
    },
  },
  data: () => ({}),
  methods: {
    openWebsite() {
      window.open(this.gameData.authorURL);
    },
    openPlatform(platform) {
      window.open(this.gameData.platforms[platform]);
    },
    openEngine() {
      let urls = {
        CC: "https://www.scirra.com/construct-classic",
        C2: "https://www.scirra.com/construct2/releases",
        C3: "https://www.construct.net/",
      };
      window.open(urls[this.gameData.engine]);
    },
  },
};
</script>

<style>
body,
.text {
  font-family: "Roboto", sans-serif !important;
  font-weight: normal;
  -webkit-user-select: none; /* Chrome 49+ */
  -moz-user-select: none; /* Firefox 43+ */
  -ms-user-select: none; /* No support yet */
  user-select: none; /* Likely future */
}
.name {
  font-size: 24pt;
  height: 34px;
  margin-left: 14px;
}
.authorImage {
  position: absolute;
  left: 1px;
  bottom: 11px;
}
.author {
  position: absolute;
  left: 38px;
  bottom: 8px;
  opacity: 0.5;
  font-size: 14pt;
  /* margin-left: 5px !important; */
}
.platforms {
  margin-left: 13px !important;
  margin-top: 5px !important;
  opacity: 0.3;
}
.ribbon {
  width: 140px;
  height: 140px;
  overflow: hidden;
  position: absolute;
}

.ribbon::before,
.ribbon::after {
  position: absolute;
  z-index: -1;
  content: "";
  display: block;
  border: 5px solid #f9a825;
}
.ribbon span {
  position: absolute;
  display: block;
  width: 225px;
  padding: 7px 0;
  background-color: #000000;
  color: #fff;
  font: 500 16px/1 "Roboto", sans-serif;
  text-transform: uppercase;
  text-align: center;
}

.indie-ribbon span {
  background-color: var(--v-indie-base);
  font-size: 10pt;
}
.indie-ribbon::before,
.indie-ribbon::after {
  border: 5px solid var(--v-indie-darken1);
}
.AAA-ribbon span {
  background-color: var(--v-AAA-base);
  font-size: 10pt;
}
.AAA-ribbon::before,
.AAA-ribbon::after {
  border: 5px solid var(--v-AAA-darken1);
}
.nsfw-ribbon span {
  background-color: var(--v-nsfw-base);
  font-size: 10pt;
}
.nsfw-ribbon::before,
.nsfw-ribbon::after {
  border: 5px solid var(--v-nsfw-darken1);
}
.wip-ribbon span {
  background-color: var(--v-wip-base);
  font-size: 10pt;
}
.wip-ribbon::before,
.wip-ribbon::after {
  border: 5px solid var(--v-wip-darken1);
}
.ea-ribbon span {
  background-color: var(--v-ea-base);
  font-size: 10pt;
}
.ea-ribbon::before,
.ea-ribbon::after {
  border: 5px solid var(--v-ea-darken1);
}

/* top left*/
.ribbon-top-left {
  top: -10px;
  left: -10px;
}
.ribbon-top-left::before,
.ribbon-top-left::after {
  border-top-color: transparent;
  border-left-color: transparent;
}
.ribbon-top-left::before {
  top: 0;
  right: 11px;
}
.ribbon-top-left::after {
  bottom: 11px;
  left: 0;
}
.ribbon-top-left span {
  right: -27px;
  top: 42px;
  transform: rotate(-45deg);
}

.badge {
  position: absolute;
  padding: 5px;
  color: #ffffff;
  font-weight: bold;
  font-size: 10px;
  z-index: 1;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* border-radius: 50%; Remove this if your image isn't a circle */
  background-size: cover; /* Add this to make your image cover the whole badge */
  background-repeat: no-repeat; /* Add this to prevent image repetition */
  transform: rotate(15deg);
}

.badge-top-right {
  top: -20px;
  right: -20px;
}

.indie-badge {
  background-image: url(~@/assets/Leaf.png);
  /*background-color: var(--v-indie-base);
  /*box-shadow: 0 0 10px rgba(255, 0, 0, 0.7); */
}

.AAA-badge {
  background-image: url(~@/assets/Leaf.png);
  /*background-color: var(--v-AAA-base);
  /*box-shadow: 0 0 10px rgba(255, 0, 0, 0.7); */
}
</style>
